import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { useWizardContext } from "../WizardContext"
import { buildDetailsPayload } from "../mappers/toApiPayload"
import { ExperienceInfo } from "../components/details/ExperienceInfo/ExperienceInfo"
import { ExperienceDetails } from "../components/details/ExperienceDetails/ExperienceDetails"
import { AdditionalDetails } from "../components/details/AdditionalDetails/AdditionalDetails"
import { PublishingSettings } from "../components/details/PublishingSettings/PublishingSettings"
import { AddOns } from "../components/details/AddOns/AddOns"
import { EXPERIENCE_TYPES } from "constants/experiences"

export const DetailsStep = () => {
  const { form, stepSaveHandlersRef, trip } = useWizardContext()
  const [searchParams] = useSearchParams()
  const listingType = searchParams.get("type")
  // For existing trips, trust the server value. URL param is only the fallback for new experiences
  // before the first save sets experience_type on the record.
  const experienceType = trip?.experience_type
    ?? (listingType === EXPERIENCE_TYPES.ticketed ? EXPERIENCE_TYPES.ticketed : EXPERIENCE_TYPES.private)

  useEffect(() => {
    // No checks here: Next checks the step first, and Save Draft may save it half-filled.
    stepSaveHandlersRef.current["details"] = async () => {
      const formValues = form.getFieldsValue()
      // add_on_ids is set via setFieldValue (no Form.Item), so getFieldsValue() omits it — read directly
      const add_on_ids = form.getFieldValue("add_on_ids") || []
      return buildDetailsPayload({ ...formValues, add_on_ids }, { experienceType })
    }
    return () => {
      delete stepSaveHandlersRef.current["details"]
    }
  }, [form, stepSaveHandlersRef, experienceType])


  return (
    <div>
      <ExperienceInfo form={form} />
      <ExperienceDetails form={form} />
      <AdditionalDetails form={form} />
      <AddOns />
      <PublishingSettings form={form} />
    </div>
  )
}
